const CategoryProductsToolbarSkeleton = () => {
  return (
    <div className="flex items-center gap-4 mb-4">
      <div className="basis-full animate-pulse">
        <div className="lg:hidden">
          <div className="h-10 w-32 bg-grey rounded"></div>
        </div>
      </div>
      <div className="basis-auto text-end animate-pulse">
        <div className="h-10 w-40 bg-grey inline-block rounded"></div>
      </div>
    </div>
  );
};

export default CategoryProductsToolbarSkeleton;
